// HAPPYCAP_SIGNUP_PHOTO_CARDS_V1
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";

export default function SignupTypeSelector() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const opciones = [
    {
      id: "self",
      titulo: t("signup_type.option_self"),
      ruta: "/signup/self",
      imagen: "/img/signup_self_photo.jpg",
      alt: t("signup_type.option_self_alt"),
    },
    {
      id: "minor",
      titulo: t("signup_type.option_minor"),
      ruta: "/signup/menor",
      imagen: "/img/signup_minor_photo.jpg",
      alt: t("signup_type.option_minor_alt"),
    },
  ];

  return (
    <>
      <div
        className="mx-auto max-w-5xl px-5 pt-5 pb-12 text-center sm:px-6 sm:pt-8"
        role="main"
        aria-labelledby="signup-type-title"
      >
        <h1
          id="signup-type-title"
          className="mb-4 whitespace-nowrap text-[clamp(1.2rem,5.5vw,1.5rem)] font-bold tracking-tight text-[#163F63] sm:whitespace-normal sm:text-4xl"
        >
          {t("signup_type.title")}
        </h1>

        <p className="mx-auto mb-7 hidden max-w-3xl text-base leading-relaxed text-slate-600 md:block md:text-lg">
          {t("signup_type.description")}
        </p>

        <div className="grid grid-cols-1 items-stretch gap-5 md:grid-cols-2 md:gap-7">
          {opciones.map((op) => (
            <button
              key={op.id}
              type="button"
              onClick={() => navigate(op.ruta)}
              className="group flex h-full w-full cursor-pointer flex-col overflow-hidden rounded-[26px] border border-white/90 bg-white p-3 text-center shadow-[0_14px_45px_rgba(22,63,99,0.09)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_55px_rgba(22,63,99,0.15)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#247BA8]/40 sm:p-4"
              aria-label={`${t("signup_type.choose")} ${op.titulo}`}
            >
              <img
                src={op.imagen}
                alt={op.alt}
                className="h-40 w-full rounded-[18px] object-cover sm:h-56 md:h-52 lg:h-56"
              />
              <div className="flex w-full flex-1 flex-col items-center px-2 pb-2 pt-5 sm:px-4 sm:pt-6">
                <h2 className="mb-5 text-xl font-bold tracking-tight text-[#163F63] sm:text-2xl">
                  {op.titulo}
                </h2>
                <span className="mt-auto flex min-h-[46px] w-full items-center justify-center gap-2 rounded-full border-2 border-[#E78B32] bg-white px-4 py-2 text-base font-semibold text-[#D76F16] transition-colors group-hover:bg-[#FFF4E8]">
                  S’inscrire <span aria-hidden="true">→</span>
                </span>
              </div>
            </button>
          ))}
        </div>

        <p className="mx-auto mt-6 max-w-xl px-2 text-sm leading-relaxed text-slate-600 md:hidden">
          {t("signup_type.description")}
        </p>
      </div>
      <Footer loginStyle />
    </>
  );
}
